<button mat-icon-button [matMenuTriggerFor]="menu" style="outline: none;">
    <mat-icon>face</mat-icon>
</button>
<mat-menu #menu="matMenu">
    <button mat-menu-item style="outline: none;">
        <span>{{name}}</span>
    </button>
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="logout()" style="outline: none;">
        <mat-icon>exit_to_app</mat-icon>
        <span>Log out</span>
    </button>
</mat-menu>
